import authRules from '../authRules.js';

const addAssignmentEditAssignmentStatus = (user) => {
  const { assignmentStatus } = user.securityLevels;
  if (assignmentStatus >= authRules.addAssignmentEditAssignmentStatus.assignmentStatus) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentEditAssignmentStatus;
